import { storage } from '@/services'

export function authHeader() {
    let user = storage.getUser()
    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}

export function authHeaderImage() {
    let user = storage.getUser()
    if (user && user.token) {
        return {
            'Authorization': 'Bearer ' + user.token,
            'Content-Type': 'multipart/form-data',
        };
    } else {
        return {};
    }
}
